import "./App.css";

function App() {
  return (
    <div className='App'>
      <header className='App-header'>My website.</header>
    </div>
  );
}

export default App;
